<template>
  <main class="dealflow-tabs mt-8 flex flex-1 flex-col min-w-0 mr-10">
    <div class="main-title flex justify-between">
      <h1 class="font-Playfair text-[32px] leading-[42.66px]">Memos</h1>
      <!-- <button
        class="flex items-center border border-borderBlack rounded text-xs leading-[15.41px] font-medium font-Rubik px-4 py-3"
        @click="openModal"
      >
        <svg
          class="h-4 w-4 text-black"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4v16m8-8H4"/>
        </svg>
        <span class="ml-2">Create new memo</span>
      </button> -->
    </div>
    <div
      :class="!dataloaded ? 'flex items-center justify-center' : ''"
      class="relative"
    >
      <div class="mt-20" v-if="!dataloaded">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: rgb(241, 242, 243); display: block; shape-rendering: auto;" width="100px" height="100px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
          <g transform="translate(26.666666666666668,26.666666666666668)">
            <rect x="-20" y="-20" width="40" height="40" fill="#000000">
              <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="1.1500000000000001;1" begin="-0.3s"></animateTransform>
            </rect>
          </g>
          <g transform="translate(73.33333333333333,26.666666666666668)">
            <rect x="-20" y="-20" width="40" height="40" fill="#636363">
              <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="1.1500000000000001;1" begin="-0.2s"></animateTransform>
            </rect>
          </g>
          <g transform="translate(26.666666666666668,73.33333333333333)">
            <rect x="-20" y="-20" width="40" height="40" fill="#e1e1e1">
              <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="1.1500000000000001;1" begin="0s"></animateTransform>
            </rect>
          </g>
          <g transform="translate(73.33333333333333,73.33333333333333)">
            <rect x="-20" y="-20" width="40" height="40" fill="#545454">
              <animateTransform attributeName="transform" type="scale" repeatCount="indefinite" dur="1s" keyTimes="0;1" values="1.1500000000000001;1" begin="-0.1s"></animateTransform>
            </rect>
          </g>
        </svg>
      </div>
      <div
        v-else
        class="flex items-center justify-center w-full"
      >

        <!-- <div class="flex flex-col items-center justify-center translate-y-[180px]">
          <span>
            <svg width="96" height="96" viewBox="0 0 96 96" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g opacity="0.6">
                    <path d="M42.6411 26.8605H67.4211C68.8011 26.8605 69.9211 25.7405 69.9211 24.3605C69.9211 22.9805 68.8011 21.8605 67.4211 21.8605H42.6411C41.2611 21.8605 40.1411 22.9805 40.1411 24.3605C40.1411 25.7405 41.2611 26.8605 42.6411 26.8605ZM70.6611 41.5405C70.6611 40.1605 69.5411 39.0405 68.1611 39.0405H44.6811C43.3011 39.0405 42.1811 40.1605 42.1811 41.5405C42.1811 42.9205 43.3011 44.0405 44.6811 44.0405H68.1611C69.5411 44.0405 70.6611 42.9205 70.6611 41.5405ZM41.3811 61.2205H65.4211C66.8011 61.2205 67.9211 60.1005 67.9211 58.7205C67.9211 57.3405 66.8011 56.2205 65.4211 56.2205H41.3811C40.0011 56.2205 38.8811 57.3405 38.8811 58.7205C38.8811 60.1005 40.0011 61.2205 41.3811 61.2205ZM34.7011 72.0205V75.0205C34.7011 80.8605 30.0811 85.6206 24.3011 85.9006C23.0011 85.9006 21.6811 85.7005 20.4211 85.2405C17.6811 84.2206 15.5211 82.2005 14.3011 79.5605C13.1011 76.9205 12.9811 73.9605 14.0011 71.2206L14.0211 71.1805C21.1011 51.5005 21.5611 29.9605 15.3611 10.0605H70.3011C76.3411 28.1805 76.4612 47.8405 70.6611 66.0205H76.9211C82.7411 46.4205 82.2011 25.3405 75.2411 6.04055L74.5211 4.06055H6.92114L8.36114 8.08055C15.4411 27.7805 15.4411 49.4606 8.36114 69.1606C6.80114 73.3806 6.96114 77.9605 8.84114 82.0605C10.7211 86.1605 14.0811 89.3006 18.3211 90.8605C20.1011 91.5206 21.9411 91.8605 23.7811 91.9205V91.9406H24.1411C24.1611 91.9406 24.2011 91.9406 24.2211 91.9406C24.2411 91.9406 24.2611 91.9406 24.3011 91.9406H72.1611C81.4811 91.9406 89.0611 84.3605 89.0611 75.0406V72.0406H34.7011V72.0205ZM30.2611 29.4605C30.6611 29.4605 31.0611 29.3005 31.3411 29.0205L38.6211 21.7405C38.9011 21.4605 39.0611 21.0805 39.0611 20.6605C39.0611 20.2605 38.9011 19.8605 38.6211 19.5805L36.9611 17.9205C36.6811 17.6405 36.2811 17.4805 35.8811 17.4805C35.4811 17.4805 35.1011 17.6405 34.8011 17.9205L30.2611 22.4605L27.7211 19.9205C27.4411 19.6405 27.0611 19.4805 26.6411 19.4805C26.2411 19.4805 25.8411 19.6405 25.5611 19.9205L23.9011 21.5805C23.6211 21.8605 23.4611 22.2605 23.4611 22.6605C23.4611 23.0605 23.6211 23.4605 23.9011 23.7405L29.1811 29.0205C29.4811 29.3005 29.8611 29.4605 30.2611 29.4605ZM41.2611 37.8405C41.2611 37.4405 41.1011 37.0405 40.8211 36.7605L39.1611 35.1005C38.8811 34.8005 38.4811 34.6405 38.0811 34.6405C37.6811 34.6405 37.3011 34.8005 37.0011 35.0805L32.4611 39.6205L29.9211 37.0805C29.6411 36.8005 29.2611 36.6405 28.8411 36.6405C28.4411 36.6405 28.0411 36.8005 27.7611 37.0805L26.1011 38.7405C25.8211 39.0205 25.6611 39.4005 25.6611 39.8205C25.6611 40.2205 25.8211 40.6205 26.1011 40.9005L31.3811 46.1805C31.6611 46.4605 32.0611 46.6205 32.4611 46.6205C32.8611 46.6205 33.2611 46.4605 33.5411 46.1805L40.8211 38.9005C41.1011 38.6205 41.2611 38.2405 41.2611 37.8405ZM22.1211 57.0205C22.1211 57.4205 22.2811 57.8005 22.5611 58.1005L27.8411 63.3805C28.1211 63.6605 28.5011 63.8205 28.9211 63.8205C29.3211 63.8205 29.7211 63.6605 30.0011 63.3805L37.2811 56.1005C37.5611 55.8205 37.7211 55.4405 37.7211 55.0205C37.7211 54.6205 37.5611 54.2405 37.2811 53.9405L35.6211 52.2805C35.3411 51.9805 34.9411 51.8205 34.5411 51.8205C34.1411 51.8205 33.7611 51.9805 33.4611 52.2605L28.9211 56.8005L26.3811 54.2605C26.1011 53.9805 25.7211 53.8205 25.3011 53.8205C24.9011 53.8205 24.5011 53.9805 24.2211 54.2605L22.5611 55.9205C22.2811 56.2205 22.1211 56.6005 22.1211 57.0205Z" fill="#828282"/>
                </g>
            </svg>
          </span>
          <p class="text-[14px] leading-[20px] text-center text-greyText my-[20px]">You are yet to create a memo.</p>
          <button
            class="flex items-center rounded text-xs leading-[15.41px] font-medium font-Rubik px-4 py-3 mt-[20px]"
            @click="openModal"
          >
            <svg
              class="h-4 w-4 text-black"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4v16m8-8H4"/>
            </svg>
            <span class="ml-2">Create new memo</span>
          </button>
        </div> -->

        <div class="my-5 border rounded-sm border-gray-200 p-6 w-full">
          <div class="flex flex-col">
            <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                <table class="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-light font-Rubik text-greyText sm:pl-6 md:pl-0">Memo Title</th>
                      <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-light font-Rubik text-greyText sm:pl-6 md:pl-0">Company Name</th>
                      <th scope="col" class="py-3.5 px-3 text-left text-sm font-light font-Rubik text-greyText">Industry</th>
                      <th scope="col" class="py-3.5 px-3 text-left text-sm font-light font-Rubik text-greyText">Date Created</th>
                      <th scope="col" class="py-3.5 px-3 text-left text-sm font-light font-Rubik text-greyText">Deal Leads</th>
                      <th scope="col" class="py-3.5 px-3 text-left text-sm font-light font-Rubik text-greyText">Current Stage</th>
                      <th scope="col" class="py-3.5 pl-10 pr-3 text-left text-sm font-light font-Rubik text-greyText">Status</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200">
                    <tr @click="goToCompanyMemo(memo.id)" v-for="memo in allMemos" :key="memo" class="cursor-pointer">
                      <td class="w-[180px] py-4 pl-4 pr-3 text-sm font-Rubik text-black sm:pl-6 md:pl-0">{{memo.title}} 🚀</td>
                      <td class="w-[130px] py-4 pl-4 pr-3 text-sm font-Rubik text-black sm:pl-6 md:pl-0">
                        <div class="flex items-center">
                          <div class="h-8 w-8 flex-shrink-0">
                            <img class="h-8 w-8 rounded-full"  :src="`${s3Bucket}${memo.logo}`" alt="" />
                          </div>
                          <div class="ml-4 text-[14px] leading-[16px]">
                            {{memo.company_name}}
                            <span class="block text-greyText text-[12px] leading-[16px] py-[2px] px-[4px] mt-[4px] bg-faintGrey rounded-[2px] max-w-[max-content]">{{memo.industry_type}}</span>
                          </div>
                        </div>
                      </td>
                      <td class="whitespace-nowrap py-4 px-3 text-sm font-Rubik text-black">{{memo.industry_type}}</td>
                      <td class="whitespace-nowrap py-4 px-3 text-sm font-Rubik text-black">{{getDate(memo.created_at)}}</td>
                      <td class="whitespace-nowrap py-4 px-3 text-sm font-Rubik text-black flex items-center sm:pl-6 md:pl-0">
                        <div class="w-9 h-9 flex-shrink-0 mr-3 rounded-full bg-coolGray-100 p-[2px]">
                          <img class="w-8 h-8 rounded-full" :src="`https://origins-files-production.s3.us-east-2.amazonaws.com/admin/${memo.deal_lead.profile_image}`" alt="">
                        </div>
                        <div class="flex flex-col items-start">
                          {{memo.deal_lead.first_name}} {{memo.deal_lead.last_name}}
                          <!-- <span class="block text-[12px] leading-[14.22px] text-greyText">{{memo.deal_lead.position}}</span> -->
                        </div>
                      </td>
                      <td class="whitespace-nowrap py-4 px-3 text-sm font-Rubik text-black">{{memo.current_stage}}</td>
                      <td class="whitespace-nowrap py-4 pl-6 pr-3 text-sm font-Rubik text-black">
                        <span v-if="memo.stage_status === 'Processing'" class="py-[6px] px-3 flex items-center justify-center bg-lightYellow text-originsYellow rounded text-[13px] leading-[15.41px] font-medium font-Rubik mr-12">
                          {{ memo.stage_status }}
                        </span>
                        <span v-if="memo.stage_status === 'Approved'" class="py-[6px] px-3 flex items-center justify-center bg-lightGreen text-originsGreen rounded text-[13px] leading-[15.41px] font-medium font-Rubik mr-12">
                          {{ memo.stage_status }}
                        </span>
                        <span v-if="memo.stage_status === 'Rejected'" class="py-[6px] px-3 flex items-center justify-center bg-lightRed text-originsRed rounded text-[13px] leading-[15.41px] font-medium font-Rubik mr-12">
                          {{ memo.stage_status }}
                        </span>
                        <!-- <span class="py-[6px] px-3 flex items-center justify-center bg-lightGreen text-originsGreen rounded text-[13px] leading-[15.41px] font-normal font-Rubik mr-12">
                          {{memo.status}}
                        </span> -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { useRouter } from 'vue-router'
// import Modal from '@/components/Modal.vue'
import { computed, reactive, ref } from 'vue'
import MemoService from '@/services/memo.service'
// import CollectionService from '@/services/collection.service'
import { useStore } from 'vuex'
import Helpers from '@/utils/helpers'
// import {
//   Listbox,
//   ListboxButton,
//   ListboxOptions,
//   ListboxOption
// } from '@headlessui/vue'
import memos from '../utils/memos'
export default {
  components: {
    // Modal,
    // Listbox,
    // ListboxButton,
    // ListboxOptions,
    // ListboxOption
  },
  setup () {
    const router = useRouter()
    const store = useStore()
    // const collections = computed(() => store.state.app.collection)
    const allMemos = ref([])
    const viewList = (id) => {
      router.push({ name: 'Company Collection Page', params: { id: id } })
    }
    const s3Bucket = process.env.VUE_APP_ORIGINS_S3_BUCKET
    const loading = ref(false)
    const allCompanies = memos.map(memo => memo.company)
    const selectedCompany = ref(allCompanies[0])
    const data = reactive({
      modalOpen: false,
      memo: false,
      memo_title: '',
      memo_company_name: computed(() => selectedCompany.value.name)
    })
    const openModal = () => {
      data.modalOpen = !data.modalOpen
    }
    const dataloaded = ref(false)
    const closeModal = () => {
      data.modalOpen = false
      data.memo = false
    }
    const fetchAllMemos = async () => {
      try {
        const response = await MemoService.getMemos()
        if (response.status === 200 && response.data.status === 'success') {
          allMemos.value = response.data.data
          dataloaded.value = true
          // collection.value = response.data.data
        }
      } catch (e) {
        dataloaded.value = false
        Helpers.processError(e, store, router)
      }
    }
    fetchAllMemos()

    const getDate = (created) => {
      const date = new Date(created.split('T')[0])
      return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }).format(date)
    }

    const createMemo = async () => {
      // eslint-disable-next-line no-unused-vars
      const memoData = {
        memo_title: data.memo_title,
        memo_company_name: data.memo_company_name
      }
      try {
        loading.value = true
        const response = await MemoService.createMemo()
        if (response.status === 200 && response.data.status === 'success') {
          loading.value = false
          data.collection = true
        }
      } catch (e) {
        loading.value = false
        Helpers.processError(e, store, router)
      }
    }

    const truncateString = (string) => {
      if (string.length > 120) {
        return string.substring(0, 120) + '...'
      } else {
        return string
      }
    }
    const goToCompanyMemo = (id) => {
      router.push({ name: 'Company Memo Page', params: { id: id } })
    }
    return {
      viewList,
      openModal,
      closeModal,
      data,
      loading,
      createMemo,
      allMemos,
      allCompanies,
      selectedCompany,
      dataloaded,
      getDate,
      truncateString,
      goToCompanyMemo,
      s3Bucket
    }
  }
}
</script>

<style>
  .list-option:not(:last-of-type) {
    border-bottom: solid 1px #E5E6E6;
  }
</style>
